import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';

import { SnBaseLayer } from './base-layer';

export class SnIntegrationLayer extends SnBaseLayer {
  @Expose()
  @Default('Integration')
  public readonly type = 'Integration';

  @Expose()
  public get image(): string {
    if (!this.integrationType) {
      return '';
    }
    return `/assets/integrations/${this.integrationType.toLowerCase()}.png`;
  }

  public set image(value: string) {}

  @Expose()
  public selfServeLpr?: boolean;

  @Expose()
  public integrationType: string = '';

  [name: string]: any;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
